<template lang="pug">
  .orders
    vue-good-table(
      ref="table"
      :columns="columns"
      :rows="orders"
      :sort-options=`{
        enabled: true,
        initialSortBy: {
          field: 'created_at',
          type: 'desc'
        }
      }`
      :pagination-options=`{
        enabled: true,
        perPage: 20,
        nextLabel: $t('pagination.next'),
        prevLabel: $t('pagination.back'),
        rowsPerPageLabel: $t('pagination.output'),
        allLabel: $t('pagination.all'),
        ofLabel: $t('pagination.of'),
      }`
      :search-options="{ enabled: false }"
      @on-row-click="onClickOrderRow"
      @on-column-filter="onColumnFilter"
    )
      div(slot="emptystate") Нет данных
      template(slot="table-row" slot-scope="props")
        span(v-if="props.column.field == 'size'")
          | {{ formatSize(props) | dimensions }}
        span(v-else-if="props.column.field == 'options'").btn-icon__wrapper.vgt-table__options-cell
          router-link.btn.btn-icon(
            title="Посмотреть карточку клиента"
            :to=`{
              name: 'clients.client',
              params: { clientId: getClientId(props.index) }
            }`
            @click.prevent="navigateToClient($event, getClientId(props.index))"
          )
            font-awesome-icon.sidebar__menu-icon(icon="user")
          router-link.btn.btn-icon(
            title="Посмотреть заказ"
            :to="{ name: 'orders.order', params: routeParams(props.index) }"
          )
            font-awesome-icon.sidebar__menu-icon(icon="eye")
          router-link.btn.btn-icon(
            title="Написать клиенту"
            :to="{ name: 'orders.order', params: routeParams(props.index), hash:'#clientdata' }"
          )
            font-awesome-icon.sidebar__menu-icon(icon="pen")

        span(v-else-if="props.column.field == 'assembly_at'")
          span(v-if="dateNotZero(props.row.assembly_at)")
            | {{ props.formattedRow[props.column.field] }}
        span(v-else-if="props.column.field == 'status'")
          | {{ $t('statuses.' + props.formattedRow[props.column.field]) }}
        span(v-else-if="props.column.field == 'client_name'")
          router-link(
            :to="{ name: 'clients.client', params: { clientId: props.row.client_id }}"
          )
            | {{ props.row.client_name }}
        span(v-else) {{ props.formattedRow[props.column.field] }}

    sweet-modal(ref="msgToClientPopup")
      h2 Написать клиенту
      .popup__body Кнопоньки
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import { VueGoodTable } from 'vue-good-table';

// Icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import config from '@/config';
import table from '@/mixins/table.mixin';

library.add(faEye);

export default {
  mixins: [table],

  data() {
    return {
      columns: [
        {
          label: '№ заказа',
          field: 'number',
          type: 'number',
          thClass: 'vgt-table__cell--min-width',
          filterOptions: {
            enabled: true,
            placeholder: '№ заказа'
          }
        },
        {
          label: 'Дата заявки',
          field: 'created_at',
          type: 'date',
          thClass: 'vgt-table__cell--min-width',
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateOutputFormat,
          filterOptions: {
            enabled: true,
            placeholder: 'Дата начала',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Тип шкафа',
          field: 'constructor_type',
          filterOptions: {
            enabled: true,
            placeholder: 'Тип шкафа',
            filterDropdownItems: this.constructorNames
          }
        },
        {
          label: 'Размеры шкафа',
          field: 'size',
          filterOptions: {
            enabled: false
          },
          sortable: true,
          sortFn: this.sortBySize
        },
        {
          label: 'Клиент',
          field: 'client_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Имя клиента'
          }
        },
        {
          label: 'Статус',
          field: 'status',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по статусу',
            filterDropdownItems: [
              { value: 'new', text: 'Новый' },
              { value: 'measurement', text: 'Ждет замер' },
              { value: 'contract', text: 'Договор' },
              { value: 'inproduction', text: 'В производстве' },
              { value: 'completed', text: 'Завершен' }
            ]
          }
        },
        {
          label: 'Опции',
          field: 'options',
          thClass: 'vgt-table__cell--min-width',
          sortable: false
        }
      ]
    };
  },

  props: {
    orders: {
      type: Array,
      required: true
    },

    showClient: {
      type: Boolean,
      required: false,
      default: true
    },

    constructorNames: {
      type: Array,
      required: true,
      default: () => []
    },

    orderStatuses: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    routeParams(rowIndex) {
      return {
        clientId: this.orders[rowIndex].client_id,
        orderId: this.orders[rowIndex].id
      };
    },

    formatSize(data) {
      return {
        width: data.row.width,
        height: data.row.height,
        depth: data.row.depth
      };
    },

    getClientId(rowIndex) {
      return this.orders[rowIndex].client_id;
    },

    dateNotZero(date) {
      return !dayjs(date).isBefore(dayjs('01.01.2018'));
    },

    onClickOrderRow(params) {
      // Prevent clicking on links
      if (
        params.event.target.tagName === 'A' ||
        params.event.target.tagName === 'path'
      ) {
        return;
      }
      this.$router.push({
        name: 'orders.order',
        params: { orderId: params.row.id }
      });
    },

    filterByStatus(status) {
      this.$set(this.columns[5].filterOptions, 'filterValue', status);
      this.$nextTick(() => {
        this.onColumnFilter();
      });
    },

    navigateToClient(e, clientId) {
      e.preventDefault();
      console.log(clientId);
    }
  },

  created() {
    if (!this.showClient) {
      this.columns = _.reject(
        this.columns,
        column => column.field === 'client_name'
      );
    }
  },

  components: {
    VueGoodTable,
    FontAwesomeIcon
  }
};
</script>
